/**
 * Homeowner and public-report wording.
 * Counsel may edit these strings. Keep claims here, not in components.
 * CommonJS only. No object spread: the iOS bundle cannot load Babel's spread helper.
 */

const LABEL_OWNER = 'Owner-reported';
const LABEL_ATTACHED = 'Document attached';
const LABEL_ON_FILE = 'Document on file (not shared)';

const LABEL_LEGEND = 'How to read the labels. Owner-reported: entered by the owner. Document attached: the owner attached a document to this item, and you can view it. Document on file (not shared): the owner has a document for this item but didn\'t include it. Pacarion doesn\'t check whether documents are genuine, complete, or match the item.';

const REPORT_FOOTER_FULL_BEFORE = 'Pacarion Home History Report. This report shows maintenance records and documents provided by the homeowner. Pacarion does not check or guarantee this information. This is not a seller disclosure, home inspection, appraisal, or warranty, and it does not replace any disclosure the seller is required to give. Buyers should get their own inspection. Sections not shared by the seller: ';

const REPORT_FOOTER_NONE = 'None';

const REPORT_FOOTER_SHORT = 'Owner-provided records. Not checked by Pacarion. Not a seller disclosure, inspection, or appraisal.';

const HOME_SYSTEMS_TITLE = 'Home Systems';
const INSTALL_YEAR_NOT_ADDED = 'Install year not added.';
const BUDGET_TIP_VENDOR_LINK = "See your sponsor's vendor list";
const BUDGET_TIP_DISMISS = 'Dismiss';

function clean(value) {
  return String(value == null ? '' : value).replace(/\s+/g, ' ').trim();
}

function sectionsNotSharedText(omitted) {
  const list = [];
  const rows = Array.isArray(omitted) ? omitted : [];
  rows.forEach((name) => {
    const text = clean(name);
    if (text && list.indexOf(text) === -1) list.push(text);
  });
  if (!list.length) return REPORT_FOOTER_NONE;
  return list.join(', ');
}

function reportFooterFull(omitted) {
  return REPORT_FOOTER_FULL_BEFORE + sectionsNotSharedText(omitted) + '.';
}

function ageFromInstallYear(year, nowYear) {
  const installed = Math.floor(Number(year));
  const current = Math.floor(Number(nowYear));
  if (!installed || !current) return null;
  const age = current - installed;
  if (age < 0 || age > 200) return null;
  return age;
}

function installedFact(year, nowYear) {
  const installed = Math.floor(Number(year));
  if (!installed) return '';
  const age = ageFromInstallYear(installed, nowYear);
  if (age == null) return 'Installed ' + installed + ' (owner-reported).';
  const span = age === 1 ? '1 year' : age + ' years';
  return 'Installed ' + installed + ' (owner-reported) · about ' + span + ' old.';
}

/**
 * Homeowner Home Systems only. The year cutoff stays in this function
 * and is never written into the sentence.
 */
function budgetPlanningTip(age) {
  const years = Math.floor(Number(age));
  if (!Number.isFinite(years) || years < 10) return '';
  return 'Based on the install year you added, this system is about ' + years
    + ' years old. Older systems may need more frequent service, so it\'s smart to plan ahead in your budget. Have a licensed pro check it.';
}

function budgetTipStorageKey(clientId) {
  return 'pacarion-home-system-budget-tip:' + String(clientId || '');
}

function parseBudgetTipDismissals(raw) {
  if (!raw) return [];
  let parsed;
  try {
    parsed = JSON.parse(String(raw));
  } catch (error) {
    return [];
  }
  if (!Array.isArray(parsed)) return [];
  const out = [];
  const seen = {};
  parsed.forEach((id) => {
    const key = clean(id);
    if (!key || seen[key]) return;
    seen[key] = true;
    out.push(key);
  });
  return out;
}

function rememberBudgetTipDismissal(ids, systemId) {
  const next = parseBudgetTipDismissals(JSON.stringify(ids || []));
  const key = clean(systemId);
  if (!key || next.indexOf(key) !== -1) return next;
  next.push(key);
  return next;
}

module.exports = {
  LABEL_OWNER,
  LABEL_ATTACHED,
  LABEL_ON_FILE,
  LABEL_LEGEND,
  REPORT_FOOTER_FULL_BEFORE,
  REPORT_FOOTER_NONE,
  REPORT_FOOTER_SHORT,
  HOME_SYSTEMS_TITLE,
  INSTALL_YEAR_NOT_ADDED,
  BUDGET_TIP_VENDOR_LINK,
  BUDGET_TIP_DISMISS,
  sectionsNotSharedText,
  reportFooterFull,
  ageFromInstallYear,
  installedFact,
  budgetPlanningTip,
  budgetTipStorageKey,
  parseBudgetTipDismissals,
  rememberBudgetTipDismissal,
};
